import gql from 'graphql-tag'
export default gql`
query getCurrencyConversionConfig( $domain: String!){
  getCurrencyConversionConfig(domain: $domain) {
    domain
    typeValue
    baseCurr
    updatedAt
    conversionList {
      curr
      value
      isDefault
      updatedAt
      updatedBy
    }
  }
}
 
# {
#   "domain":"sd"
# }

`